export default {"src":"/_next/static/media/icDownTrend.06420792.svg","height":14,"width":10,"blurWidth":0,"blurHeight":0};